import { Component, Input } from '@angular/core';

import { isSituacaoAtivo, isSituacaoInativo } from '../mercado-situacao';

@Component({
    selector: 'sgt-mercado-situacao-badge',
    templateUrl: './mercado-situacao-badge.component.html',
    styleUrls: ['./mercado-situacao-badge.component.less']
})
export class MercadoSituacaoBadgeComponent {
    /** Situação do mercado */
    @Input() situacao: number;

    /** Verifica se a situação do mercado é Ativo */
    isSituacaoAtivo(): boolean {
        return isSituacaoAtivo(this.situacao);
    }

    /** Verifica se a situação do mercado é Inativo */
    isSituacaoInativo(): boolean {
        return isSituacaoInativo(this.situacao);
    }
}
